import { ReactNode, useEffect, useRef, useState } from 'react';
import { ScrollArea, Spacer } from '@qapline/ui';
import classNames from 'classnames';
import { Container } from 'modules/ui/components/Container';

import styles from './PageContent.module.scss';

export type PageContentProps = {
    fullWidth?: boolean;
    fullWidthHeader?: boolean;
    subheader?: ReactNode;
    children: ReactNode;
    scrollable?: boolean;
};

export const PageContent: React.FC<PageContentProps> = ({
    children,
    subheader,
    fullWidth,
    fullWidthHeader,
    scrollable,
}) => {
    const [contentWidth, setContentWidth] = useState(1400);

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setContentWidth(ref.current?.offsetWidth || 1400);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref.current]);

    const containerOverflowTheScreen = document.body.offsetWidth < contentWidth;

    return (
        <>
            {subheader && (
                <div className={styles.subheaderWrapper}>
                    <div
                        className={styles.content}
                        style={{ width: fullWidth || fullWidthHeader ? '100%' : `${contentWidth}px` }}
                    >
                        {subheader}
                    </div>
                </div>
            )}
            {subheader && <div className={styles['artificial-gap']} />}
            {scrollable ? (
                <ScrollArea
                    className={classNames(styles.contentSection, styles.scrollable)}
                    classNames={{ content: styles.scrollContent }}
                >
                    <Spacer size={7} dir="vertical" />
                    <Container fullWidth={fullWidth} style={{ marginInline: 'auto' }}>
                        {children}
                    </Container>
                    <Spacer size={7} dir="vertical" />
                </ScrollArea>
            ) : (
                <div className={classNames(styles.contentSection, styles.nonScrollable)}>
                    <Container fullWidth={fullWidth}>{children}</Container>
                </div>
            )}
        </>
    );
};
